export default {
    name: 'Smart Principles',
    type: 'template',
    preview: 'https://cdn.affine.pro/templates/cover/smart.png',
    content: {
        type: 'page',
        meta: {
            id: 'page:home',
            title: '',
            createDate: 1702975489152,
            tags: [],
        },
        blocks: {
            type: 'block',
            id: 'block:Ivoa5vCv2_',
            flavour: 'affine:page',
            props: {
                title: {
                    '$blocksuite:internal:text$': true,
                    delta: [],
                },
            },
            children: [
                {
                    type: 'block',
                    id: 'block:c1LHIBVL-J',
                    flavour: 'affine:surface',
                    props: {
                        elements: {
                            VLFZ71iAHv: {
                                type: 'shape',
                                xywh: '[-3351.0058452256562,-193.49281224272409,1208.450254579689,271]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-green',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'VLFZ71iAHv',
                                index: 'Zt',
                                seed: 1658518971,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 24,
                            },
                            UILf85BFpp: {
                                type: 'text',
                                xywh: '[-2998.213531614515,123.77868158453771,501.8040785351991,1153.5726457174703]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'S',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-green',
                                fontSize: 823.9804612267642,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'UILf85BFpp',
                                index: 'a9',
                                seed: 1020737877,
                            },
                            c9MSESV7E3: {
                                type: 'shape',
                                xywh: '[-3351.0058452256562,121.16593109577366,1207.3887057574816,1158.7981466949982]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-green',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'c9MSESV7E3',
                                index: 'Zy',
                                seed: 2113251578,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 200,
                            },
                            '2ZxoDqhiPD': {
                                type: 'text',
                                xywh: '[-3298.7807179358115,-99.9648970050714,1104,143]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'The goal should be clear and specific, avoiding vagueness or generalities. This helps to focus efforts and clearly define what is to be achieved.',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '400',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: '2ZxoDqhiPD',
                                index: 'a0V',
                                seed: 1773635052,
                                hasMaxWidth: true,
                            },
                            qclPNRzVNH: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        c9MSESV7E3: true,
                                        UILf85BFpp: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Specific',
                                        },
                                    ],
                                },
                                id: 'qclPNRzVNH',
                                index: 'Zy',
                                seed: 1204682767,
                            },
                            ZoZvdltCAo: {
                                type: 'shape',
                                xywh: '[-2085.320761846566,121.1659310957732,1207.3887057574816,1158.7981466949982]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-magenta',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'ZoZvdltCAo',
                                index: 'aQ',
                                seed: 81413652,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 200,
                            },
                            QMFfwtaW9y: {
                                type: 'text',
                                xywh: '[-1852.6264089678255,123.77868158453771,742,1236]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'M',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-magenta',
                                fontSize: 823.9804612267642,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'QMFfwtaW9y',
                                index: 'aR',
                                seed: 796986841,
                            },
                            '2bAcAezJdW': {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        ZoZvdltCAo: true,
                                        QMFfwtaW9y: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Measurable',
                                        },
                                    ],
                                },
                                id: '2bAcAezJdW',
                                index: 'Zx',
                                seed: 292574324,
                                xywh: '[-1152.4771618726809,1113.4513332126337,1207.3887057574816,1158.7981466949984]',
                            },
                            CRv9moZesq: {
                                type: 'shape',
                                xywh: '[-819.6356784674756,121.16593109577366,1207.3887057574816,1158.7981466949982]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-purple',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'CRv9moZesq',
                                index: 'aT',
                                seed: 167876713,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 200,
                            },
                            '1L3b654uwZ': {
                                type: 'text',
                                xywh: '[-511.4413255887348,123.77868158453816,591,1236]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'A',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-purple',
                                fontSize: 823.9804612267642,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '1L3b654uwZ',
                                index: 'aU',
                                seed: 1736175608,
                            },
                            jMeVKfk3tN: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        CRv9moZesq: true,
                                        '1L3b654uwZ': true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Attainable',
                                        },
                                    ],
                                },
                                id: 'jMeVKfk3tN',
                                index: 'Zw',
                                seed: 1524523375,
                                xywh: '[118.29908958978649,1116.0640837013977,1207.3887057574816,1158.798146694998]',
                            },
                            Vkf_8k3sFH: {
                                type: 'shape',
                                xywh: '[446.0494049116146,121.16593109577366,1207.3887057574816,1158.7981466949982]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'Vkf_8k3sFH',
                                index: 'aW',
                                seed: 1685399219,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 200,
                            },
                            'pZVwJ-Wk8e': {
                                type: 'text',
                                xywh: '[785.2437577903554,123.77868158453816,529,1236]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'R',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-yellow',
                                fontSize: 823.9804612267642,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'pZVwJ-Wk8e',
                                index: 'aX',
                                seed: 1272467178,
                            },
                            d0ic8no_hD: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        Vkf_8k3sFH: true,
                                        'pZVwJ-Wk8e': true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Relevent',
                                        },
                                    ],
                                },
                                id: 'd0ic8no_hD',
                                index: 'Zv',
                                seed: 1665773977,
                                xywh: '[1389.0753410522548,1101.3271266282566,1207.3887057574816,1158.7981466949984]',
                            },
                            jZNAL4_O2f: {
                                type: 'shape',
                                xywh: '[1711.7344882907043,121.16593109577366,1207.3887057574816,1158.7981466949982]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-orange',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'jZNAL4_O2f',
                                index: 'aZ',
                                seed: 2126278060,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 200,
                            },
                            '7uEKqL4ZZE': {
                                type: 'text',
                                xywh: '[2077.428841169445,123.77868158453816,476,1236]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'T',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-orange',
                                fontSize: 823.9804612267642,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '7uEKqL4ZZE',
                                index: 'aa',
                                seed: 1879860187,
                            },
                            '5eCtP90W6E': {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        jZNAL4_O2f: true,
                                        '7uEKqL4ZZE': true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Time-bound',
                                        },
                                    ],
                                },
                                id: '5eCtP90W6E',
                                index: 'Zu',
                                seed: 488603175,
                                xywh: '[2659.851592514723,1103.939877117021,1207.3887057574816,1158.7981466949984]',
                            },
                            Ht75_MNgKj: {
                                type: 'text',
                                xywh: '[-3298.7807179358115,-159.02072748037654,128.3199462890625,45]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Specific',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: 'Ht75_MNgKj',
                                index: 'a1',
                                seed: 963242182,
                            },
                            'aRxdJtEB-h': {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        VLFZ71iAHv: true,
                                        '2ZxoDqhiPD': true,
                                        Ht75_MNgKj: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Specific',
                                        },
                                    ],
                                },
                                id: 'aRxdJtEB-h',
                                index: 'a1',
                                seed: 681263561,
                            },
                            'hEcVf-73Rp': {
                                type: 'shape',
                                xywh: '[-2085.320761846566,-193.49281224272409,1208.450254579689,271]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-magenta',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'hEcVf-73Rp',
                                index: 'a2',
                                seed: 1675439228,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 24,
                            },
                            eGKmonZQA1: {
                                type: 'text',
                                xywh: '[-2033.095634556721,-99.96489700507118,1104,143]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'The goal must have criteria for measuring progress and success. This allows for tracking of progress and knowing when the objective has been achieved.',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '400',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: 'eGKmonZQA1',
                                index: 'a3',
                                seed: 1994121851,
                                hasMaxWidth: true,
                            },
                            YSfTlyVK_E: {
                                type: 'text',
                                xywh: '[-2033.095634556721,-159.02072748037654,195,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Measurable',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: 'YSfTlyVK_E',
                                index: 'a4',
                                seed: 2117656022,
                            },
                            wyAA7JCOkb: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        'hEcVf-73Rp': true,
                                        eGKmonZQA1: true,
                                        YSfTlyVK_E: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Measurable',
                                        },
                                    ],
                                },
                                id: 'wyAA7JCOkb',
                                index: 'a5',
                                seed: 1137197974,
                                xywh: '[-914.7524361865326,1259.971277553842,1208.450254579689,271]',
                            },
                            O3Dna1QDkc: {
                                type: 'shape',
                                xywh: '[-819.6356784674756,-193.49281224272409,1208.450254579689,271]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-purple',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'O3Dna1QDkc',
                                index: 'a6',
                                seed: 1324901350,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 24,
                            },
                            FMeqaDNTPp: {
                                type: 'text',
                                xywh: '[-767.4105511776313,-99.96489700507118,1104,143]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'The goal should be attainable; that is, realistically within the reach of the individual or team. It should challenge skills but remain possible.',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '400',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: 'FMeqaDNTPp',
                                index: 'a7',
                                seed: 1043066726,
                                hasMaxWidth: true,
                            },
                            ykjWb35sxt: {
                                type: 'text',
                                xywh: '[-767.4105511776313,-159.02072748037654,173,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Attainable',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: 'ykjWb35sxt',
                                index: 'a8',
                                seed: 1392138820,
                            },
                            '6lwwdy2C3y': {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        O3Dna1QDkc: true,
                                        FMeqaDNTPp: true,
                                        ykjWb35sxt: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Measurable',
                                        },
                                    ],
                                },
                                id: '6lwwdy2C3y',
                                index: 'a9',
                                seed: 990615727,
                                xywh: '[343.81424374502603,1279.136236898279,1208.450254579689,271]',
                            },
                            txSWSSW1WR: {
                                type: 'shape',
                                xywh: '[446.0494049116146,-193.49281224272409,1208.450254579689,271]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'txSWSSW1WR',
                                index: 'aA',
                                seed: 2145441580,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 24,
                            },
                            bn6Mjrgz1a: {
                                type: 'text',
                                xywh: '[498.274532201459,-99.96489700507072,1104,143]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'The goal should be relevant to the direction you want your career, business, or project to head. This means that it aligns with other relevant goals and fits into your immediate and long-term plans.',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '400',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: 'bn6Mjrgz1a',
                                index: 'aB',
                                seed: 435820474,
                                hasMaxWidth: true,
                            },
                            sLYia2zuPE: {
                                type: 'text',
                                xywh: '[498.2745322014589,-159.02072748037654,144,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Relevant',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: 'sLYia2zuPE',
                                index: 'aC',
                                seed: 1120374089,
                            },
                            lly0yHh_jh: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        txSWSSW1WR: true,
                                        bn6Mjrgz1a: true,
                                        sLYia2zuPE: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Measurable',
                                        },
                                    ],
                                },
                                id: 'lly0yHh_jh',
                                index: 'aD',
                                seed: 1287003439,
                                xywh: '[1623.8355831302415,1272.136182495278,1208.450254579689,271]',
                            },
                            CrDcOkbe1K: {
                                type: 'shape',
                                xywh: '[1711.7344882907043,-193.49281224272409,1208.450254579689,271]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-orange',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'CrDcOkbe1K',
                                index: 'aE',
                                seed: 276312892,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                color: '--affine-palette-line-black',
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                fontSize: 24,
                            },
                            '81PZhIh4Nr': {
                                type: 'text',
                                xywh: '[1763.959615580549,-99.96489700507072,1104,143]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'The goal should have a defined timeline, including a starting date and a target date. The purpose is to create urgency and prompt action.',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '400',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: '81PZhIh4Nr',
                                index: 'aF',
                                seed: 1167709234,
                                hasMaxWidth: true,
                            },
                            q7RAxQNyB_: {
                                type: 'text',
                                xywh: '[1763.9596155805486,-159.02072748037654,206,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Time-bound',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 32,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                id: 'q7RAxQNyB_',
                                index: 'aG',
                                seed: 523238549,
                            },
                            YIccwkH2Ml: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        CrDcOkbe1K: true,
                                        '81PZhIh4Nr': true,
                                        q7RAxQNyB_: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Time-bound',
                                        },
                                    ],
                                },
                                id: 'YIccwkH2Ml',
                                index: 'aH',
                                seed: 222388655,
                                xywh: '[2889.65386881657,1266.969332380398,1208.450254579689,271]',
                            },
                            p5bQwSREqj: {
                                type: 'text',
                                xywh: '[-4342.619006596488,-13.057358174548929,829,486]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'A SMART principle template is designed to help in setting effective goals or objectives by ensuring they are Specific, Measurable, Achievable, Relevant, and Time-bound. \n\nThis template typically includes sections or prompts for each of these criteria, guiding you to refine your goals to be clear, trackable, realistic, significant, and timely.',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 36,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'p5bQwSREqj',
                                index: 'aI',
                                seed: 1898609963,
                                hasMaxWidth: true,
                            },
                            gmi1BanjpX: {
                                type: 'text',
                                xywh: '[-4342.619006596488,-95.45854395335401,327.3598937988281,56]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'SMART principle',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 40,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'gmi1BanjpX',
                                index: 'aJ',
                                seed: 1251120640,
                            },
                            jsgVCjYWKk: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        p5bQwSREqj: true,
                                        gmi1BanjpX: true,
                                        'block:cdEnXNXJqL': true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Group 11',
                                        },
                                    ],
                                },
                                id: 'jsgVCjYWKk',
                                index: 'aK',
                                seed: 690304037,
                            },
                        },
                    },
                    children: [],
                },
                {
                    type: 'block',
                    id: 'block:AO4FlzLUUZ',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[-3223.3589643662244,339.75646448917877,364,347.93359375]',
                        background: '--affine-tag-green',
                        index: 'aC',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:z0m-ULBS3e',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:r5uLaWvJGq',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[-2617.79493007147,595.3326572305407,364,347.93359375]',
                        background: '--affine-tag-green',
                        index: 'aD',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:O0e0O5kYaE',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:Fh0N_Q2YCF',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[-1989.6804700600383,831.1723973608521,364,347.93359375]',
                        background: '--affine-tag-red',
                        index: 'a2',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:SU1xoMmCbb',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:RA_jEg2E70',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[-1343.4990461792797,211.11551460456477,364,347.93359375]',
                        background: '--affine-tag-red',
                        index: 'a3',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:f4kKCTYgv7',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:j_eHKl28GX',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[-709.4578878641801,240.00984558562732,364,347.93359375]',
                        background: '--affine-tag-purple',
                        index: 'a4',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:7jxyj-iGql',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:FKUgxhkKlp',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[-39.05825514573803,526.5982075682728,364,347.93359375]',
                        background: '--affine-tag-purple',
                        index: 'a5',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:0-ngzmshRA',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:Vo-f0AP4L7',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[517.7720751423635,595.3326572305407,364,347.93359375]',
                        background: '--affine-tag-yellow',
                        index: 'a6',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:MiCy_xnKcg',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:WEjuudYmBb',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[1246.7638970121116,240.00984558562732,364,347.93359375]',
                        background: '--affine-tag-yellow',
                        index: 'a7',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:SqUH7pHvqX',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:XnkUM8MtsU',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[2442.2113962118606,651.1518547540968,364,347.93359375]',
                        background: '--affine-tag-yellow',
                        index: 'a8',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 0,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-sticker',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:x0_111mG5P',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
                {
                    type: 'block',
                    id: 'block:cdEnXNXJqL',
                    flavour: 'affine:note',
                    props: {
                        xywh: '[-4419.195197448199,-178.63371373620782,982.1523817034204,692.5167086864009]',
                        background: '--affine-background-secondary-color',
                        index: 'aE',
                        hidden: false,
                        edgeless: {
                            style: {
                                borderRadius: 24,
                                borderSize: 4,
                                borderStyle: 'none',
                                shadowType: '--affine-note-shadow-paper',
                            },
                            collapse: true,
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:vdxqM55sW6',
                            flavour: 'affine:paragraph',
                            props: {
                                type: 'text',
                                text: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [],
                                },
                            },
                            children: [],
                        },
                    ],
                },
            ],
        },
    },
};
//# sourceMappingURL=smart-principles.js.map